/** La pagina «Yuma sul sito» della console (30/10/2026): le conversazioni dei visitatori di yumaos.com con Yuma. */
export default {
  titolo: 'Yuma sul sito',
  sottotitolo:
    'Le conversazioni dei visitatori di yumaos.com con Yuma, come le hanno viste loro. Restano 12 mesi, o per sempre quando la persona si iscrive alla lista d’attesa.',
  aggiorna: 'Aggiorna',
  spesa: {
    accesa: 'Yuma è accesa',
    spenta: 'Yuma è spenta',
    oggi: 'Spesa di oggi',
    tetto: 'su un tetto di {{tetto}} al giorno',
    trenta: 'Ultimi 30 giorni',
  },
  impostazioni: {
    cambiaTetto: 'Cambia il tetto',
    nuovoTetto: 'Tetto del giorno, in dollari',
    salva: 'Salva il tetto',
    annulla: 'Annulla',
    interruttore: 'Yuma risponde sul sito',
    salvato: 'Impostazione salvata.',
    errore: 'Impostazione non salvata: {{motivo}}',
    spiegazioneTetto: 'Oltre il tetto Yuma risponde che per oggi ha finito e manda alla lista d’attesa. Ti arriva un’email a metà e al tetto.',
  },
  filtri: {
    etichetta: 'Quali conversazioni',
    tutte: 'Tutte',
    con_modulo: 'Con il modulo pronto',
    iscritti: 'Diventate iscrizioni',
  },
  elenco: {
    vuoto: 'Ancora nessuna conversazione. Appena un visitatore scrive a Yuma, la trovi qui.',
    vuotoFiltro: 'Nessuna conversazione con questo filtro fra quelle caricate.',
    altre: 'Carica le conversazioni precedenti',
    senzaNome: 'Visitatore senza nome',
    messaggi_one: '{{count}} messaggio',
    messaggi_other: '{{count}} messaggi',
    daPagina: 'da {{pagina}}',
    paginaDiYuma: 'dalla pagina di Yuma',
  },
  stato: {
    iscritto: 'Iscritto',
    modulo: 'Modulo pronto',
  },
  dettaglio: {
    scegli: 'Scegli una conversazione dall’elenco per leggerla.',
    indietro: 'Tutte le conversazioni',
    iniziata: 'Iniziata il {{data}}',
    costo: 'Costo {{costo}}',
    scade: 'Si cancella da sola il {{data}}',
    perSempre: 'Resta per sempre con l’iscrizione',
    apriIscritto: 'Apri la scheda dell’iscritto',
    detto: 'Detto a voce',
    riassunto: 'Il riassunto che Yuma ha scritto per noi',
    caricamento: 'Caricamento della conversazione…',
  },
  schede: {
    video: 'Video «{{slug}}», dal secondo {{secondo}}',
    pagina: 'Pagina mostrata',
    conto: 'Conto proposto',
    mensile: 'al mese',
    annuale: 'all’anno',
    totale: 'Totale, IVA esclusa',
    marchio: 'Marchio letto dal sito',
    modulo: 'Modulo della lista d’attesa preparato',
    risposte_one: '{{count}} risposta compilata',
    risposte_other: '{{count}} risposte compilate',
  },
  iscritto: {
    titolo: 'Ha parlato con Yuma sul sito',
    apri: 'Leggi la conversazione',
  },
  errori: {
    elenco: 'Le conversazioni non si sono caricate: {{motivo}}',
    conversazione: 'La conversazione non si è caricata: {{motivo}}',
  },
} as const;
